import { useEffect, useState } from "react";

const useColumnDrawer = ({columns, onSave}: {columns: any; onSave: any}) => {
  const [drawerColumns, setDrawerColumns] = useState(columns);

  useEffect(() => {
    setDrawerColumns(columns);
  }, [columns]);

  const onApply = () => {
    onSave(drawerColumns);
  }

  const onChangeCol = (key: string, checked: boolean) => {
    const col = drawerColumns?.map((data: any) => ({...data, checked: data.key == key ? checked : data.checked}));
    setDrawerColumns([...col]);
  }

  return {
    drawerColumns,
    onApply,
    onChangeCol
  }
}

export default useColumnDrawer;